module.exports = __webpack_public_path__ + "static/media/dem_lon_rea.d64f5e7a.png";